import React from 'react';
import { Popover, Button } from 'antd';

/**
 * RowActionPopover
 * Reusable popover that shows action buttons for a row on small screens
 * Props:
 *  - width: current viewport width (number)
 *  - rowId: unique identifier for the row (string|number)
 *  - openRowId: current open row id (string|number|null)
 *  - setOpenRowId: setter function to update open row
 *  - content: ReactNode to render inside popover
 *  - buttonClassName: optional class for trigger button
 *  - showLabel: boolean (default true) whether to show text label inside button
 *  - showText: custom label for closed state (default 'Show Action')
 *  - hideText: custom label for open state (default 'Hide Action')
 *  - placement: popover placement (default 'bottomRight')
 *  - disabled: optional disable state for trigger
 */
const RowActionPopover = ({
  width,
  rowId,
  openRowId,
  setOpenRowId,
  content,
  buttonClassName = 'copy-button mt-1',
  showLabel = true,
  showText = 'Show Action',
  hideText = 'Hide Action',
  placement = 'bottomRight',
  disabled = false,
}) => {
  if (width > 768) return null; // Only render trigger in small view
  const isOpen = openRowId === rowId;
  return (
    <Popover
      placement={placement}
      open={isOpen}
      onOpenChange={(visible) => { if (!visible) setOpenRowId(null); }}
      trigger="click"
      styles={{ body: { padding: '12px' } }}
      content={content}
    >
      <Button
        disabled={disabled}
        className={buttonClassName}
        onClick={(e) => {
          e.stopPropagation();
          if (isOpen) setOpenRowId(null); else setOpenRowId(rowId);
        }}
      >
        {showLabel ? (isOpen ? hideText : showText) : null}
      </Button>
    </Popover>
  );
};

export default RowActionPopover;
